import { useState, useEffect, useRef } from "react";
import { useConfig } from "./ConfigContext";

import { formatCurrency } from "./pureFunctions";
import { Form } from "react-bootstrap";

export default function SocialMedia({ basicdata, userObjects, user }) {
   const config = useConfig();

   const [text, setTextField] = useState(() => {
      const selectObject = JSON.parse(localStorage.getItem("oOfieldConfiguration"));
      return `${basicdata.objekttitel.replace(/360°?\s?\|?/g, "")} 🗝️
 
✔️ Objektart: ${selectObject.estate.objektart.permittedvalues[basicdata.objektart]}
✔️ Zimmer: ${basicdata.anzahl_zimmer}
✔️ Wohnfläche: ca. ${basicdata.wohnflaeche} m²${
         basicdata.grundstuecksflaeche > 0
            ? `
✔️ Grundstück: ca. ${basicdata.grundstuecksflaeche} m²`
            : ""
      }
✔️ Kaufpreis: ${formatCurrency(basicdata.kaufpreis)}
 
Energieausweis

Energieausweistyp: ${selectObject.estate.energieausweistyp.permittedvalues[basicdata.energieausweistyp]}
Heizungsart: ${basicdata.heizungsart.map((item) => selectObject.estate.heizungsart.permittedvalues[item])}
wesentliche Energieträger: ${basicdata.befeuerung.map((item) => selectObject.estate.befeuerung.permittedvalues[item])}
${basicdata.energieausweistyp === "Energieverbrauchskennwert" ? `Energieendbedarf: ${basicdata.energieverbrauchskennwert}` : `Energieendbedarf: ${basicdata.endenergiebedarf}`} kWh/(m²a)
Energieeffizienzklasse: ${basicdata.energyClass}
Gültig bis: ${new Date(basicdata.energieausweis_gueltig_bis).toLocaleDateString()}

Ansprechpartner: ${userObjects[basicdata.benutzer] && userObjects[basicdata.benutzer].Vorname + " " + userObjects[basicdata.benutzer].Nachname}
Objekt-ID: ${basicdata.objektnr_extern}
Tel: 0751 56156-0
info@baur-immobilien.de
 
👉 Mehr Informationen und Bilder finden Sie hier:
Link_zur_Website_hinzufügen
 
Jetzt Such-Auftrag erstellen und automatisch benachrichtigt werden:
baur-immobilien.de/kaufen/suchauftrag
 `;
   });

   return (
      <div className="mt-3">
         <Form>
            <Form.Group className="mb-3" key="abc">
               <Form.Label>SocialMedia-Text (Änderungen werden nicht gespeichert)</Form.Label>
               <Form.Control
                  as="textarea"
                  placeholder=""
                  style={{ minHeight: "115px", fieldSizing: "content" }}
                  onChange={(e) => {
                     setTextField(e.target.value);
                  }}
                  value={text}
               />
            </Form.Group>
         </Form>
      </div>
   );
}
